import { useCallback, useEffect, useMemo, useState } from 'react';
import { fetchCampaignHubupNotifications } from '../api/campaigns';
import {
  mergePublishedHubupNotifications,
  publishedHubupNotificationsFromCampaign,
  publishedHubupNotificationsFromMessages,
} from '../utils/campaignEmailTemplate';

/**
 * Notifications pour l’email : historique campagne + messages HubUP
 * (scrapés côté serveur via la communauté liée à la campagne).
 */
export function useCampaignHubupPublishedNotifications(campaign) {
  const campaignId = String(campaign?._id || campaign?.id || '').trim();
  const groupId = String(campaign?.hubupGroupId || '').trim();
  const [messages, setMessages] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [reloadToken, setReloadToken] = useState(0);

  const refetch = useCallback(() => {
    setReloadToken((n) => n + 1);
  }, []);

  useEffect(() => {
    if (!campaignId || !groupId) {
      setMessages([]);
      setError(null);
      setLoading(false);
      return undefined;
    }
    let cancelled = false;
    (async () => {
      setLoading(true);
      setError(null);
      try {
        const res = await fetchCampaignHubupNotifications(campaignId);
        if (cancelled) return;
        setMessages(res?.data?.messages || []);
      } catch (e) {
        if (!cancelled) {
          setMessages([]);
          setError(
            e?.message ||
              'Impossible de récupérer les notifications depuis HubUP.',
          );
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    })();
    return () => {
      cancelled = true;
    };
  }, [campaignId, groupId, reloadToken]);

  const published = useMemo(() => {
    const fromCampaign = publishedHubupNotificationsFromCampaign(campaign);
    if (!groupId) return fromCampaign;
    const fromMessages = publishedHubupNotificationsFromMessages(messages, campaign);
    return mergePublishedHubupNotifications(fromCampaign, fromMessages);
  }, [campaign, groupId, messages]);

  return { published, loading, error, groupId, refetch };
}
